import React from "react";
import { useGTM } from "../hooks/use-GTM";
import { useSelector } from "react-redux";

export default function GTMInitializer() {
  const profileDD = useSelector((state) => state.profileDetails.profileDetails);
  const GTM_ID = process.env.REACT_APP_GTM_ID;

  const default_data = {
    Unique_ID: profileDD?.jcUserId,
    Entry_Source: "jiocloud web",
  };

  useGTM(GTM_ID, default_data);
  return (
    <>
      <noscript>
        <iframe
          title="gtm"
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        />
      </noscript>
    </>
  );
}
